export default __webpack_public_path__ + "static/the-voice-17233fc367cd53df93f5ff36da34f8a3.png";